module.exports = __webpack_public_path__ + "primeicons.473e2a746d3c151d7dca.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/trevor/src/src-westoaks3/west-oaks/node_modules/primeicons/fonts/primeicons.ttf
// module id = ../../../../primeicons/fonts/primeicons.ttf
// module chunks = styles